import { ChangeSocial } from 'commands/business/social/ChangeSocial';

export class ChangeTwitter extends ChangeSocial {
  type: string = 'ChangeTwitter';
}
